// extracted by mini-css-extract-plugin
export var activeCard = "testimonials-module--active-card--a0c7d";
export var card = "testimonials-module--card--39396";
export var cards = "testimonials-module--cards--26bc3";
export var person = "testimonials-module--person--f840b";
export var spin = "testimonials-module--spin--054d9";
export var testimonials = "testimonials-module--testimonials--f0f81";
export var testimonials__black = "testimonials-module--testimonials__black--cf2a7";
export var testimonials__bloodorange = "testimonials-module--testimonials__bloodorange--03cba";
export var testimonials__chartruse = "testimonials-module--testimonials__chartruse--a108d";
export var testimonials__cobalt = "testimonials-module--testimonials__cobalt--2d9d6";
export var testimonials__emerald = "testimonials-module--testimonials__emerald--4bbac";
export var testimonials__paper = "testimonials-module--testimonials__paper--5ca3a";
export var testimonials__pink = "testimonials-module--testimonials__pink--b426b";
export var testimonials__sky = "testimonials-module--testimonials__sky--76a10";
export var testimonials__small = "testimonials-module--testimonials__small--c14d7";
export var testimonials__white = "testimonials-module--testimonials__white--1cbcb";
export var title = "testimonials-module--title--d13e0";